import React from 'react';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';

// components
import BaseModal from 'common/modals/BaseModal';

let SetPrimaryModal = ({
  onCancelSetPrimaryModal,
  onSaveSetPrimaryModal,
  scriptId,
  setPrimaryModal
}) => setPrimaryModal ? (
  <BaseModal
    onCancel={() => { onCancelSetPrimaryModal(); }}
    onSave={() => { onSaveSetPrimaryModal({ scriptId }); }}
    saveText={getMessage('button-text__save-changes')}
    shouldCloseOnOverlayClick={false}>
    {getMessage('help-text__set-primary')}
  </BaseModal>
) : null;
  
SetPrimaryModal.propTypes = {
  onCancelSetPrimaryModal: propTypes.func.isRequired,
  onSaveSetPrimaryModal: propTypes.func.isRequired,
  scriptId: propTypes.string,
  setPrimaryModal: propTypes.object
};

export default SetPrimaryModal;